import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Stack, Text } from 'shell/components';

export const ADMIN_OVERRIDE_STATE = Object.freeze({
    MAY_OVERRIDE: 1,
    OVERRIDDEN: 2,
});

const NOTICE_CONTENT = {
    [ADMIN_OVERRIDE_STATE.MAY_OVERRIDE]: {
        titleKey: 'settings.admin-override.may-override.title',
        titleFallback: 'Overwrite May Occur:',
        descriptionKey: 'settings.admin-override.may-override.description',
        descriptionFallback:
            "Your institution's admin may override these settings. If admin-level preferences are applied, they will take priority over your personal settings.",
    },
    [ADMIN_OVERRIDE_STATE.OVERRIDDEN]: {
        titleKey: 'settings.admin-override.overridden.title',
        titleFallback: 'Overwritten By Admin:',
        descriptionKey: 'settings.admin-override.overridden.description',
        descriptionFallback:
            "This setting is managed by your institution's admin. Admin settings currently take priority over your personal preference.",
    },
};

const AdminOverrideNotice = ({ state }) => {
    const { t } = useTranslation();
    const content = NOTICE_CONTENT[state];
    if (!content) return null;

    return (
        <Notice role='note' spacing={0.5} $state={state}>
            <Text weight='medium'>{t(content.titleKey, content.titleFallback)}</Text>
            <Text>{t(content.descriptionKey, content.descriptionFallback)}</Text>
        </Notice>
    );
};

const Notice = styled(Stack)(({ $state, theme }) => ({
    alignItems: 'flex-start',
    background:
        $state === ADMIN_OVERRIDE_STATE.OVERRIDDEN
            ? theme.palette.ensightful.error[100]
            : theme.palette.ensightful.warning[100],
    borderRadius: 16,
    padding: theme.spacing(2.5),
    p: {
        color:
            $state === ADMIN_OVERRIDE_STATE.OVERRIDDEN
                ? theme.palette.ensightful.error[900]
                : theme.palette.ensightful.warning[900],
    },
}));

export default AdminOverrideNotice;
